export default __webpack_public_path__ + "static/media/social_badge.215e79a2.png";